import React from 'react';
import { Formik } from 'formik';
import { Form, InputNumber, FormItem, Radio } from 'formik-antd';
import { Button, Alert, Divider, notification } from 'antd';
import { useHistory } from 'react-router-dom';

import { ROUTE_EMPLOYER_PREFIX } from 'utils/routes';
import { LayoutPage } from 'components/layouts';
import Client from 'containers/app/client';

const initialValues = {
  amount: 1,
};

const bundles = [1, 10, 20, 50, 100];

const help = `An email will be sent to your organisation admin requesting the amount of tokens you set in the following form.`;

const RequestTokens = () => {
  const history = useHistory();
  const handleSubmit = async (values, { setStatus, setSubmitting }) => {
    setSubmitting(true);
    try {
      await Client.requestTokens(values);
      notification.success({
        title: 'Request sent!',
        message: `${values.amount} Tokens requested to the organisation admin.`,
      });
      setSubmitting(false);
      history.push(`${ROUTE_EMPLOYER_PREFIX}/dashboard`);
    } catch (error) {
      setSubmitting(false);
      setStatus({ message: error.message, type: 'error' });
    }
  };

  return (
    <LayoutPage className="buy-tokens-page">
      <LayoutPage.Container className="wrapper">
        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
          {({ isSubmitting, status, setStatus }) => {
            return (
              <Form layout="vertical" className="wrapper">
                <h1>Request Tokens</h1>
                <Divider />
                {status != null ? (
                  <>
                    <Alert
                      closable
                      message={status.message}
                      type={status.type}
                      onClose={() => {
                        setStatus(undefined);
                      }}
                    />
                    <Divider />
                  </>
                ) : null}
                <Alert
                  description={help}
                  type="info"
                  style={{ marginBottom: 'var(--margin-02)' }}
                />
                <FormItem
                  name="amount"
                  label="How many tokens would you like to request?"
                >
                  <Radio.Group name="amount">
                    {bundles.map((bundle, i) => (
                      <Radio.Button key={i} value={bundle}>
                        {bundle}
                      </Radio.Button>
                    ))}
                  </Radio.Group>
                  <InputNumber name="amount" />
                </FormItem>
                <Button
                  style={{ width: '100%' }}
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  loading={isSubmitting}
                  disabled={isSubmitting}
                >
                  Request Tokens
                </Button>
              </Form>
            );
          }}
        </Formik>
      </LayoutPage.Container>
    </LayoutPage>
  );
};

export default RequestTokens;
